import { css } from '@emotion/css';
import React, { HTMLAttributes } from 'react';

type ResortEmphasisProps = HTMLAttributes<HTMLSpanElement> & { color: string };

export const ResortEmphasis: React.FC<ResortEmphasisProps> = ({ children, color, ...rest }) => {
  const encodedColor = encodeURIComponent(color);
  const emphasisSideImage = `data:image/svg+xml,%3Csvg width="12" height="25" viewBox="0 0 12 25" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M4.905 4.041c-2.26-1.689-.195-4.178 2.09-2.47a14.467 14.467 0 013.319 3.358c1.108 1.66-.654 2.866-2.065 1.782-1.157-.883-1.913-1.601-3.344-2.67zM1.723 13.598c-2.768-.546-1.982-3.685.82-3.129 1.558.284 3.059.821 4.442 1.592 1.713 1.025.65 2.87-1.093 2.504-1.426-.303-2.421-.62-4.169-.967zM3.788 23.805c-2.65.976-3.564-1.997-.928-3.1a10.802 10.802 0 014.076-.815c1.996 0 2.045 2.109.366 2.704-1.371.483-1.84.6-3.514 1.21z" fill="${encodedColor}"/%3E%3C/svg%3E`;
  return (
    <span
      className={css`
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 0 4px;
      &::before,
      &::after {
        content:'';
        background-image: url('${emphasisSideImage}');
        position: absolute;
        width: 12px;
        height: 25px;
      }
      &::before {
        left: -12px;
      }
      &::after {
        right: -12px;
        transform: scaleX(-1);
      }
    `}
      {...rest}
    >
      {children}
    </span>
  );
};
